import {
  Layout,
  Notification,
  NotificationProps,
} from '@kira/checkpoint-shared-frontend';
import React, { useContext, useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import Header from 'components/Header/Header';
import NavigationLink from 'components/Header/NavigationLink';
import { t } from 'locales/i18n';
import { AssessmentDetailsContext } from 'providers/AssessmentDetailsProvider';
import { NotificationContext } from 'providers/NotificationProvider';

const Home = () => {
  const { interviewUid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const notificationProps = useContext(
    NotificationContext
  ) as NotificationProps;
  const { isPractice } = useContext(AssessmentDetailsContext);

  useEffect(() => {
    const isMatch = [
      /\/overview/,
      /\/steps\/all-steps/,
      /\/steps\/competency\/w+/,
      /\/settings\/general/,
    ].some((url) => url.test(location.pathname));

    if (isPractice && !isMatch) {
      navigate(`/interview/${interviewUid}/overview`);
    }
  }, [isPractice]);

  return (
    <>
      <Layout>
        <Header showAvatar showBackground assessmentUid={interviewUid}>
          <NavigationLink
            to={`/interview/${interviewUid}/overview`}
            textContent={t('Overview')}
          />
          <NavigationLink
            to={`/interview/${interviewUid}/steps`}
            textContent={t('Steps')}
          />
          <NavigationLink
            to={`/interview/${interviewUid}/settings`}
            textContent={t('Settings')}
          />
        </Header>
        <ContentContainer contentClasses="2xl:container 2xl:mx-auto">
          <Outlet />
        </ContentContainer>
      </Layout>

      <Notification {...notificationProps} />
    </>
  );
};

export default Home;
